import Layout from "../components/Layouts";
import Nav from "../components/Navi";
import Footer from "../components/Footers";
import CountdownBar from "../components/CountdownBar";
import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
export default function Privacy() {
    const { t } = useTranslation("common");
    return (
        <>
            <div className="page-default">
                <div className="container en mt-5">
                    <h1 className="fw-bold">Privacy Policy for Hayya Media Portal </h1>

                    <h3 className="pt-4">1 - About this Policy</h3>
                    <p>
                        1.1 The Supreme Committee for Delivery & Legacy (
                        <strong>SC, we, us</strong>) is committed to protecting and respecting
                        your privacy. SC was established in the State of Qatar by Emiri Decree
                        No. (27) of 2011 as amended by Emiri Decree No. (3) of 2014 and its
                        principal place of business is at Al Bidda Tower, P.O. Box 62022,
                        Doha, State of Qatar.
                    </p>
                    <p>
                        1.2 This Privacy Policy sets out the basis on which we will process
                        any personal information that we may collect about you, including when
                        you visit our Platforms; or otherwise interact with us or use our
                        services. “Platforms”, and other terms are defined in{" "}
                        <strong>Annex A</strong>.
                    </p>
                    <p>
                        1.3 We may provide further privacy notices to you at the point we
                        collect your personal data, which will highlight any further
                        information relating to our use of that personal data and, where
                        applicable, provide you with the ability to opt in or out of selected
                        uses.
                        {/* If you are a volunteer, a fan leader, or local country host
                        (through our “Host a Fan” programme), separate privacy notices will
                        apply to you, and these can be found on the specific website for your
          programme. */}
                    </p>

                    <h3 className="pt-4">2 - The information that we collect about you</h3>
                    <p>
                        2.1	We may collect and/or process information about you when you engage with us,
                        in particular, when you use our Hayya Media Portal available at https://media.hayya.qa/ Details of the
                        personal data we process, the purposes for which we do so, and the
                        third parties we share data with, are set out in the Annex B .
                    </p>
                    <p>
                        2.2 In general, however, we may collect and/or process the following
                        categories of information about you:
                    </p>
                    <ul className="pb-3">
                        <li className="pb-2 ps-sm-3">
                            (a) <strong>Information that you provide to us ►</strong> This
                            includes information you provide when filling out application,
                            registration or contact forms on our Platforms.{" "}
                        </li>
                        <li className="py-2 ps-sm-3">
                            (b) <strong>Platform and communication usage ►</strong> Information
                            that our Platform collect about you, including details of your
                            visits to the Platform, your internet protocol (IP) address, domain
                            name, browser version and operating system, traffic data, weblogs
                            and other communication data, and the resources that you access. The
                            Platform may also download cookies to your device, as described in
                            our separate Cookies Policy{" "}
                            <a href="https://media.hayya.qa/cookie-policy">
                                https://media.hayya.qa/cookie-policy
                            </a>
                        </li>
                        <li className="py-2 ps-sm-3">
                            (c) <strong>Our correspondence ►</strong> If you contact us, we may
                            keep a record of that correspondence.
                        </li>
                        <li className="py-2 ps-sm-3">
                            (d) <strong>Your feedback ►</strong> Information which you provide
                            to us from time to time by completing surveys or polls, and which we
                            use to help us improve our offerings.
                        </li>
                    </ul>
                    <p>
                        2.3 We may also receive information about you from third parties who
                        are legally entitled to disclose that information. If you wish to know
                        more about how these third parties handle your personal information,
                        please contact them directly.
                    </p>
                    <p>
                        2.4 We do not collect personal data from persons under the age of 18 (
                        <strong>Minors</strong>) without their legal guardian’s consent. We
                        take specific steps to protect the privacy of Minors who disclose
                        their personal identifying information to us, and we shall take all
                        reasonable steps required of us to protect the rights of Minors and
                        their privacy under applicable laws and regulations, including the
                        laws of the State of Qatar.
                    </p>

                    <h3 className="pt-4">3 - What we do with your information? </h3>
                    <p>
                        3.1 In this section, we set out the purposes for which we use personal
                        data described in this Privacy Policy, and the “legal grounds” on
                        which we rely to process your personal data for that purpose:
                    </p>
                    <ul className="pb-3">
                        <li className="pb-2 ps-sm-3">
                            {" "}
                            (a){" "}
                            <strong>
                                To communicate effectively with you and conduct our operations ►
                            </strong>
                            To ensure that our Platform functions well and the event applied for run smoothly; to register and manage your accounts
                            on the Platforms; to respond to your queries; to communicate and develop our relationship with you; and to carry out our
                            obligations arising from any arrangements between you and us.
                            <br />
                            <br />
                            <i>Lawful bases:</i> contract performance, legitimate interests (to
                            enable us to perform our obligations and provide our services to
                            you)
                        </li>
                        <li className="py-2 ps-sm-3">
                            (b) <strong>To provide you with marketing materials ►</strong> To
                            provide you with updates and offers, where you have chosen to
                            receive these. We may use your information for marketing our own and
                            our selected business partners’ products, services, events and
                            opportunities to you by post, email, SMS, phone, in-app marketing,
                            and through social media channels. Where required by law, we will
                            ask for your consent at the time we collect your data to conduct any
                            of these types of marketing. We will provide an option to
                            unsubscribe or opt-out of further communication on any electronic
                            marketing communication sent to you or you may opt out by contacting
                            us as set out in the “Marketing” section below.
                            <br />
                            <br />
                            <i>Lawful bases:</i>
                            consent, legitimate interests (to keep you updated with news in
                            relation to our products, services, events and opportunities).
                        </li>
                        <li className="py-2 ps-sm-3">
                            (c) <strong>For research and development purposes ►</strong> To
                            analyse your personal information and use of our Platform in order
                            to better understand your and other applicants’ preferences and requirements,
                            to better develop and organise our products, services
                            and events. <br />
                            <br />
                            <i>Lawful bases:</i> legitimate interests (to allow us to improve
                            our products, services, and events).
                        </li>
                        <li className="py-2 ps-sm-3">
                            (d) <strong>To inform you of changes ►</strong> To notify you about
                            changes to our products, services, and events.
                            <br />
                            <br />
                            <i>Lawful bases:</i>
                            legitimate interests (to notify you about changes to our products,
                            services, and events).
                        </li>
                        <li className="py-2 ps-sm-3">
                            (e) <strong>To ensure Platform content is relevant ►</strong> To
                            provide you with a personalised browsing experience when using the
                            Platform, including by ensuring that content from our Platform is
                            presented in the most effective manner for you and for your device.
                            This may include passing your data to business partners, suppliers
                            and/or service providers.
                            <br />
                            <br />
                            <i>Lawful bases:</i> legitimate interests (to allow us to provide
                            you with relevant content and services on the Platform).
                        </li>
                        <li className="py-2 ps-sm-3">
                            (f){" "}
                            <strong>To re-organise or make changes to our business ►</strong> In
                            the event that we undergo a re-organisation, we may need to transfer
                            some or all your personal data to the relevant third party (or its
                            advisors) as part of any due diligence process for the purpose of
                            analysing any proposed re-organisation. We may also need to transfer
                            your personal data to that re-organised entity or third party after
                            the reorganisation for them to use for the same purposes as set out
                            in this policy.
                            <br />
                            <br />
                            <i>Lawful bases:</i> legitimate interests (in order to allow us to
                            change our business).
                        </li>
                        <li className="py-2 ps-sm-3">
                            (g){" "}
                            <strong>
                                In connection with legal or regulatory obligations ►
                            </strong>{" "}
                            We may process your personal data to comply with our regulatory
                            requirements, to dialogue with regulators, or to bring and defend
                            claims, as applicable. This may include disclosing your personal
                            data to third parties, the court service and/or regulators or law
                            enforcement agencies in connection with enquiries, proceedings or
                            investigations by such parties anywhere in the world or where
                            compelled to do so.
                            <br />
                            <i> Lawful bases</i>: legal obligations, legal claims, legitimate
                            interests (to cooperate with law enforcement and regulatory
                            authorities).
                        </li>
                        <li className="py-2 ps-sm-3">
                            (h){" "}
                            <strong>
                                To ensure the safety and security of our operations, premises, and
                                events ►
                            </strong>{" "}
                            To keep attendees of Tournaments safe and secure, including by
                            investigating, preventing or taking action in relation to actual or
                            suspected illegal activities, fraud, emergency situations involving
                            potential threats to the physical safety of any persons or
                            violations to our internal policies or terms of use; or to prevent
                            the spread of viruses or infectious diseases.
                            <br />
                            <br /> Lawful bases: legal
                            obligations, legitimate interests (to prevent fraud and ensure
                            physical, IT and network safety and security).
                        </li>
                    </ul>

                    <h3 className="pt-4">4 - Sharing with Third Parties</h3>
                    <p>
                        4.1 We may share your personal information with third parties and
                        affiliates for the purposes we explain in this Privacy Policy. These
                        third parties include:
                    </p>
                    <ul className="pb-3">
                        <li className="pb-2 ps-sm-3">
                            (a) our service providers, such as those which host the Platform or
                            other information technology systems, or who otherwise hold or
                            process your personal information on our behalf.
                        </li>
                        <li className="py-2 ps-sm-3">
                            (b) contractors, agents, or advisors (e.g. legal, financial,
                            business or other advisors) that perform activities on our behalf.
                        </li>
                        <li className="py-2 ps-sm-3">
                            (c) government agencies, including the Ministry of Public Health,
                            Ministry of Interior and the Ministry of Transport and
                            Communications, so that they may carry out any checks required to
                            ensure the safety and security of the Tournaments; and
                        </li>
                        <li className="py-2 ps-sm-3">
                            (d) any organisation which takes over our operations, or relevant
                            parts of them.
                        </li>
                    </ul>
                    <p>
                        4.2 In exceptional circumstances, we may be under a duty to disclose
                        or share your personal data in order to comply with any legal
                        obligation (including responding to requests from law enforcement
                        authorities either within or outside of the State of Qatar), or in
                        order to enforce or apply our Terms of Use, or the terms of other
                        agreements that we are party to; or to protect our rights, property,
                        or safety, or that of our partners, or other relevant third parties
                        and affiliates. This includes exchanging information with other
                        organisations for the purposes of fraud protection.
                    </p>
                    <p>
                        4.3 The Platform may contain links to other third-party websites. If
                        you follow a link to any of those third-party websites, please note
                        that they have their own privacy policies and that we do not accept
                        any responsibility or liability for their policies or processing of
                        your personal data. Please check these policies before you submit any
                        personal data to such third-party websites.
                    </p>

                    <h3 className="pt-4">5 - Marketing</h3>
                    <p>
                        5.1 As mentioned, we may use your data, or permit selected third
                        parties or affiliates to use your data, to provide you with
                        information about goods and services which may be of interest to you
                        and we or they may contact you about these by post, email, SMS, phone,
                        in-app marketing or through social media channels, provided that you
                        give us consent for this (where consent is required by law).{" "}
                    </p>
                    <p>
                        5.2 If, at any time after you have given us consent to do so, you no
                        longer want us to use your data in this way, or to pass your details
                        on to third parties or affiliates for marketing purposes, please get
                        in touch with us using the details in the “Contacting us” section
                        below, and provide us with the following information:
                    </p>
                    <ul className="pb-3">
                        <li className="pb-2 ps-sm-3">
                            • Which mode(s) of contact you wish to receive marketing by post/
                            email/ SMS/ phone/ in-app marketing/ through social media channels.
                        </li>
                        <li className="py-2 ps-sm-3">
                            • Which topics you wish to receive marketing on.
                        </li>
                    </ul>
                    <h3 className="pt-4">6 - Profiling and Automated Decision Making</h3>
                    <p>
                        6.1 The advertisements and recommendations which we show you on our
                        Platform are chosen by analysing the personal information you provide
                        to us, including, but not limited to, information you have provided
                        about your preferences, the way in which you interact with our
                        Platform, and previous advertisements which you have clicked on. To
                        choose advertisements which are tailored and most likely to be of
                        interest to you, we compile and analyse information received from all
                        our users to gain a better understanding of your preferences from
                        users like you.{" "}
                    </p>
                    <h3 className="pt-4">7 - Storage and Security</h3>
                    <p>
                        7.1 All information you provide to us is stored on our subcontractors’
                        secure servers and accessed and used subject to our security policies
                        and standards. Where we have given you (or where you have chosen) a
                        password which enables you to access certain parts of our Platform,
                        you are responsible for keeping this password confidential and for
                        complying with any other security procedures that we notify you of. We
                        ask you not to share a password with anyone.{" "}
                    </p>
                    <p>
                        7.2 No data transmission over the Internet or website can be
                        guaranteed to be secure from intrusion. However, we maintain
                        commercially reasonable physical, electronic, and procedural
                        safeguards to protect your personal data in accordance with data
                        protection legislative requirements.
                    </p>
                    <h3 className="pt-4">8 - International transfer of your information</h3>
                    <p>
                        8.1 Your personal information may be transferred to and/or stored in
                        Qatar, or at another a destination located outside of your country.
                        Such data may also be processed by persons operating overseas who work
                        for us, or by our affiliates or one of our third-party service
                        providers.
                    </p>
                    <p>
                        8.2 This may include transfers to countries whose privacy laws may be
                        of a lower standard than those in your country. In those cases, we
                        will ensure that our arrangements with our service providers or other
                        third parties are governed by appropriate safeguards or agreements.
                        Where we are required by law to do so we will provide a copy of such
                        safeguards.
                    </p>
                    <h3 className="pt-4">9 - Retention and deletion of your information</h3>
                    <p>
                        9.1 Our retention periods for personal data are based on business
                        needs and legal requirements. We retain personal data for as long as
                        is necessary for the processing purpose(s) for which the information
                        was collected, and any other permissible, related purpose. For
                        example, we may retain a copy of your Hayya Media Portal Application to comply with
                        regulatory requirements regarding the retention of such data. When
                        personal data is no longer needed, we either irreversibly anonymise
                        the data (and we may further retain and use the anonymised
                        information) or securely destroy the data.
                    </p>
                    <h3 className="pt-4">10 - Your Rights</h3>
                    <p>
                        10.1 Where processing of your personal information is based on your
                        consent, you have the right to withdraw it at any time. Please note
                        that the withdrawal of your consent will not affect the lawfulness of
                        processing based on your consent as carried out before such
                        withdrawal.{" "}
                    </p>
                    <p>
                        10.2 We will use reasonable endeavours to ensure that your personal
                        data is accurate. To assist us with this, you should notify us of any
                        changes to the personal data that you have provided to us by
                        contacting us as set out in the “Contacting Us” section below.
                    </p>
                    <p>
                        10.3 Under certain conditions, you may have the right to require us
                        to:{" "}
                    </p>
                    <ul className="pb-3">
                        <li className="pb-2 ps-sm-3">
                            (a) provide you with a copy of information that you have provided to
                            us;
                        </li>
                        <li className="py-2 ps-sm-3">
                            (b) update any inaccuracies in the personal data we hold (please see
                            paragraph ‎10.2 above);
                        </li>
                        <li className="py-2 ps-sm-3">
                            (c) delete any personal data we no longer have a lawful ground to
                            use;
                        </li>
                        <li className="py-2 ps-sm-3">
                            (d) where processing is based on consent, to withdraw your consent
                            so that we stop that particular processing (see paragraph ‎5 above
                            in relation to marketing);
                        </li>
                        <li className="py-2 ps-sm-3">
                            (e) ask us to transmit the personal data you have provided to us,
                            and we still hold about you to a third party electronically;
                        </li>
                        <li className="py-2 ps-sm-3">
                            (f) object to any processing based on the legitimate interests
                            ground unless our reasons for undertaking that processing outweigh
                            any prejudice to your data protection rights; and
                        </li>
                        <li className="py-2 ps-sm-3">
                            (g) restrict how we use your information whilst a complaint is being
                            investigated.
                        </li>
                    </ul>
                    <p>
                        10.4 Your exercise of these rights is subject to certain exemptions to
                        safeguard the public interest (e.g. the prevention or detection of
                        crime) and our interests (e.g., the maintenance of legal privilege).
                        If you exercise any of these rights, please contact us (details in the
                        “Contacting Us” section below). We will check your entitlement and
                        respond in most cases within a month.{" "}
                    </p>
                    <p>
                        10.5 You can also lodge a complaint about our processing of your
                        personal information with the appropriate data protection authority in
                        Qatar at the Ministry of Transport and Communications if you consider
                        that the processing of your personal information infringes applicable
                        law. In Qatar this is the competent department at the Ministry of
                        Transport and Communications. In the UK it is the Information
                        Commissioner’s Office, and a list of supervisory authorities in the EU
                        can be found here:{" "}
                        <a
                            href="https://edpb.europa.eu/about-edpb/about-edpb/members_en"
                            target="_blank" rel="noreferrer"
                        >
                            https://edpb.europa.eu/about-edpb/about-edpb/members_en
                        </a>
                    </p>
                    <h3 className="pt-4">11 - Changes to this Policy</h3>
                    <p>
                        11.1 Any changes we make to this Privacy Policy in the future will be
                        posted to the Platform and are also available if you contact us.
                        Please check back frequently to see any changes. If we change this
                        Privacy Policy or our Cookies Policy, we will update the date it was
                        last changed below. If these changes are material, we will indicate
                        this clearly on our Platform(s).
                    </p>
                    <h3 className="pt-4">12 - Contacting us</h3>
                    <p>
                        12.1 If you have any questions in relation to this Privacy Policy,
                        please email <a href="emailto:privacy@hayya.qa">privacy@hayya.qa</a>
                    </p>
                    <br />
                    <br />
                    <br />
                    <br />
                    <h3 className="pt-5 text-center">ANNEX A</h3>
                    <h3 className="text-center">Definitions</h3>

                    <p className="pt-4">
                        {" "}
                        1 In this Privacy Policy, the following words shall have the following
                        meanings:
                    </p>

                    <ul className="pt-2">
                        <li className="py-2 ps-sm-3">
                            1.1 <b>You</b> the <b>Applicants</b>, means any person who makes application for registration through the Hayya Media Portal(HMP).
                        </li>
                        <li className="py-2 ps-sm-3">
                            1.2 <b>Application</b> means an application for registration through the HMP in accordance with these terms
                        </li>
                        <li className="py-2 ps-sm-3">
                            1.3 <b>Events</b> means the event Media has applied for accreditation for through the HMP.
                        </li>

                        {/* <li className="py-2 ps-sm-3">
                            1.1 <b>Fan</b> means an individual who attends, or plans to attend,
                            one of more of our Tournaments.
                        </li>
                        <li className="py-2 ps-sm-3">
                            1.2 <b>Host Country Media</b> means non-FIFA accredited media
                            representatives including written press, web-based media, TV and
                            radio journalists, technicians, photographers, and social media
                            influencers.
                        </li> */}
                        <li className="py-2 ps-sm-3">
                            1.4 <b>Hayya Media Portal (HMP)</b> means the website and
                            related mobile applications through which Host Country Media can
                            apply for accreditation and/or permits to cover the Tournaments and
                            have access to media contents and services, and which is hosted at
                            https://media.hayya.qa.
                        </li>
                       
                        <li className="py-2 ps-sm-3">
                            1.6 <b>Hayya Site</b> means the website hosted at <a href="https://media.hayya.qa">https://media.hayya.qa</a>
                        </li>
                        <li className="py-2 ps-sm-3">
                            1.7 <b>Media</b> means all media representatives including but not limited to, written press, web based media,
                            TV and radio journalists, technicians, photographers and social media influencers.
                        </li>
                        <li className="py-2 ps-sm-3">
                            1.5 <b>Platform</b> means the Hayya Media Portal or
                            any other platforms which SC may offer from time to time; and
                            Platforms means two or more of these platforms (as the context
                            requires).
                        </li>
                        {/* <li className="py-2 ps-sm-3">
                            1.5 <b>Qatar 2022 Site</b> means the website hosted at
                            https://qatar2022.qa.
                        </li>

                        <li className="py-2 ps-sm-3">
                            1.6 <b>Tournament</b> means the FIFA Arab Cup 2021TM or the FIFA
                            World Cup Qatar 2022TM, and <b>Tournaments</b> means both of these
                            events.
                        </li>
                        <li className="py-2 ps-sm-3">
                            1.7 <b>Hayya Media Portal Application</b> means an application on the Hayya Media Portal.
                        </li> */}
                    </ul>

                    <br />
                    <br />
                    <br />
                    <br />
                    <h3 className="pt-5 text-center">Annex B</h3>
                    <h3 className="text-center">
                        Hayya Media Portal
                    </h3>
                    <p className="pt-4">
                        {" "}
                        <b>1. Additional information that we collect about you</b>
                    </p>

                    <ul className="pt-2">
                        <li className="py-2 ps-sm-3">
                            To be able to access exclusive Host Country media content, full
                            range of services, apply for Host Country Media accreditation and
                            Qatar entry permit, you should first register with the Hayya Media Portal. For these purposes, we may ask you to provide:
                        </li>
                        <li className="py-2 ps-sm-3">
                            (a) Basic information about yourself, such as your name, date of
                            birth, address, email address, telephone or mobile number.
                        </li>
                        <li className="py-2 ps-sm-3">
                            (b) Details about your nationality and passport (e.g., passport
                            number, issue date, expiry date).
                        </li>
                        <li className="py-2 ps-sm-3">
                            (c) Your photograph, which may form part of your passport, press
                            card, accreditation badges for previous events or other types of
                            professional credentials.
                        </li>
                        <li className="py-2 ps-sm-3">
                            (d) Information about the company for which you work (e.g.,
                            company’s name and registration number, and your job title at the
                            company).
                        </li>
                        <li className="py-2 ps-sm-3">
                            (e) We may also ask for media information about you and/or your
                            company such as media type, frequency of published media
                            information, language, and reach.
                        </li>
                        <li className="py-2 ps-sm-3">
                            We may also receive information about you from the following third
                            parties:
                        </li>
                        <li className="py-2 ps-sm-3">
                            (a) <strong>Background information ►</strong> The Qatar Ministry of
                            Interior (
                            <a href="http://www.moi.gov.qa" target="_blank">
                                http://www.moi.gov.qa
                            </a>
                            ) may send us background check status information which will inform
                            our decision on whether to accept or reject your application for
                            accreditation as a media representative at the Tournament(s).
                        </li>
                    </ul>

                    <p className="pt-4"> 2. Additional purposes of use</p>

                    <ul className="pt-2">
                        <li className="py-2 ps-sm-3">
                            (a){" "}
                            <strong>
                                To provide you with information about and services and benefits
                                available to media representatives ►
                            </strong>{" "}
                            To select and provide you with information in relation to the
                            services and benefits.
                            <br />
                            <i>Lawful bases:</i> contract performance, legitimate interests (to
                            enable us to perform our obligations and provide our services to
                            you)
                        </li>
                        <li className="py-2 ps-sm-3">
                            (b){" "}
                            <strong>
                                To consider you/ your company’s application for accreditation
                                and/or permit(s) ►
                            </strong>{" "}
                            To carry out all necessary checks regarding your application; to
                            liaise with relevant government agencies to obtain approval for your
                            visit to Qatar and provide coverage of the Tournament; to issue and
                            deliver your media accreditation badge.
                            <br />
                            <i>Lawful bases:</i> contract performance, legitimate interests (to
                            enable us to consider your application and provide our services to
                            you) you)
                        </li>
                        <li className="py-2 ps-sm-3">
                            (c){" "}
                            <strong>
                                To provide you with media content updates and a selection of
                                services ►
                            </strong>{" "}
                            To provide you with information about events, press conferences,
                            match results, images, videos, transport and accommodation
                            recommendations, and other information to assist with your stay in
                            Qatar and your coverage of the Tournament. We may provide you with
                            marketing materials where you have chosen to receive these (see the
                            section titled “What we do with your information?” in the main
                            Privacy Policy).
                            <br />
                            <i>Lawful bases:</i> consent, legitimate interests (to keep you
                            updated with information in relation to your stay in Qatar and media
                            coverage of the Tournament(s))
                        </li>
                        <li className="py-2 ps-sm-3">
                            (d){" "}
                            <strong>
                                To manage the supply of media facilities and the number of media
                                attendees at each event during the Tournament ►
                            </strong>{" "}
                            To aggregate your booking request details (e.g. to attend a specific
                            press conference, or to book a media studio) together with that of
                            other media representatives, and analyse it so as to ensure that
                            there are sufficient media facilities available, and to allocate
                            facilities and passes to press conferences etc. based on available
                            supply.
                            <br />
                            <i>Lawful bases:</i> contract performance, legitimate interests (to
                            enable us to perform our obligations and provide our services to
                            you).
                        </li>
                    </ul>
                </div>
            </div>
            {/* <CountdownBar /> */}
        </>
    );
}

Privacy.getLayout = function getLayout(page) {
    return (
        <Layout>
            <Nav />
            {page}
            <Footer />
        </Layout>
    );
};

export async function getStaticProps({ locale }) {
    return {
        props: {
            ...(await serverSideTranslations(locale, ["common"])),
        },
    };
}
